import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import { selectTheme } from '../../store/theme/selectors';
import { events, trackEvent } from '../../lib/analytics';

export const enhance = compose(
  connect((state) => ({ currentProduct: selectTheme(state) })),
  withHandlers({
    handleDisabledClick: () => (event) => event.preventDefault(),
    handleClick:
      ({ id, link, onClick, currentProduct }) =>
      (event) => {
        id = id || link?.fields?.id;
        id &&
          trackEvent(events.BUTTON_CLICK, {
            label: id,
            category: currentProduct,
          });
        onClick && onClick(event);
      },
  })
);
